import React, { Fragment, useState } from 'react';
import { post } from '../../../Services/http';
import { translate } from '../../../Services/translation';

const ReactivateFromPausePopUp = (props) => {
    const [generalErrors, setgeneralErrors] = useState([]);    


    const reactivateSubscriptionNow = () => {
      post(`/api/customer/reactivatesubscriptionnow/${props.customerSystemId}`)
        .then(() => {
          props.hidePopUp();      
          props.refresh();  
        })
        .catch((error) => {
          if (error.response.status === 500) {
            setgeneralErrors([translate('coptikk.adminportal.subscription.generalerror')]);
            setTimeout(() => {
              props.hidePopUp();
              props.refresh();
            }, 1000);
          }
        });
    }


    return (<Fragment>
        <div className='subscription__popup-container'>
            <div className='subscription__popup-content'>
                {generalErrors && generalErrors.length > 0 && generalErrors.map(errorItem => {
                    return <div className='error'>{errorItem}</div>
                })}
                
                    <div className='add-to-cart-pop-up__close' onClick={() => props.hidePopUp()}></div>                    
                    <h2 className='subscription-pop-up__title'>{props.adminPortal ? translate("coptikk.adminportal.reactivatefrompause.header")
                    : translate("coptikk.general.reactivatefrompause.header")}</h2>                    
                    <p className='subscription-pop-up__description'>
                        {props.adminPortal ? translate("coptikk.adminportal.reactivatefrompause.description") : 
                        translate("coptikk.general.reactivatefrompause.description")}
                    </p>                    
                        <a className='subscription-pop-up__pause-button' onClick={() => reactivateSubscriptionNow()}>
                            {props.adminPortal ? translate("coptikk.adminportal.reactivatefrompause.sendnowbuttontext")
                            : translate("coptikk.general.reactivatefrompause.sendnowbuttontext")}</a>
                        <a className='subscription-pop-up__cancel-button' onClick={() => {
                            props.hidePopUp(); 
                            props.reactivateSubscription();
                        }}>{props.adminPortal ? translate("coptikk.adminportal.reactivatefrompause.waitlinktext") : 
                            translate("coptikk.general.reactivatefrompause.waitlinktext")}</a>                                    
            </div>
        </div>
    </Fragment>)
}

export default ReactivateFromPausePopUp;